import { Component, h, Listen, State } from "@stencil/core";
import i18nextInstance from "../../utils/i18n";

/**
 * Error Component - offers to reload the page
 */
@Component({
  tag: 'ad-error',
  styleUrl: 'ad-error.css',
  shadow: false,
})


export class AdessoError {

    @State() isTranslated : boolean = false;

    @Listen('translationsLoaded', {target: 'window'})
    translationsLoadedHandler() {
        this.isTranslated = true;
    }

    onClickHandler(e:MouseEvent) {
        e.preventDefault();
        location.reload();
    }

    render() {
        return (
            <div class="error" role="alert">
                <p class="headline">{i18nextInstance.t('error_general')} <ad-icon icon="link-slash fa-2xl"></ad-icon></p>
                <p>{i18nextInstance.t('error_reloadHint')}</p>
                <button class="btn tick" onClick={this.onClickHandler.bind(this)} tabindex="0" role="button">{i18nextInstance.t('error_reload')}</button>
            </div>
        );
    }
}